module.exports = __webpack_public_path__ + "img/cancel-subscription.f92f180a.svg";